// extracted by mini-css-extract-plugin
export default {"CrossSellCard":"CrossSellCard_CrossSellCard","header":"CrossSellCard_header","iconWrapper":"CrossSellCard_iconWrapper"};